import { format, parse } from 'date-fns';


const redirectToHttps = () => {
    const domain = window.location.hostname;
    if(domain !== 'localhost'){
        let url = window.location.href;
        if(!url.includes('https')){
            url = url.replace('http', 'https');
            window.location.href = url;
        }
    }
};


/** Helper function to get the current url of this React application. */
const getAppUrl = () => {
    const domain = window.location.hostname;
    if(domain === 'localhost'){
        return `http://localhost:3000`;
    }
    const APPUrls = {
        production: 'https://payments.revitpay.com',
        staging: 'https://hawksoft-epaymintsgatew-stagingui-dxfbddgge7hpamap.westus2-01.azurewebsites.net',
        development: `http://localhost:3000`
    };
    return APPUrls[process.env.REACT_APP_ENV];
};


/** Helper function to get the current URL of the Node API for this application. */
const getApiUrl = () => {
    // const domain = window.location.hostname;
    // if(domain === 'localhost'){
    //     return `http://localhost:8080`;
    // }
    const APIUrls = {
        production: 'https://lobster-app-grzos.ondigitalocean.app',
        staging: 'https://hawksoft-epaymintsgatew-staging-cvf4axdpb8hke7dx.westus2-01.azurewebsites.net',
        development: `http://localhost:8080`
    };
    return APIUrls[process.env.REACT_APP_ENV];
};

// Set the base URLs
const API_URL = getApiUrl();   // url to run the API from
const BASE_URL = getAppUrl();  // url to run the UI from

const isStaging = () => process.env.REACT_APP_ENV !== 'production';



const TOKEN_COOKIE = 'persistence-key';


const isLocal = () => {
    const domain = window.location.hostname;
    return domain === 'localhost';
};


const CustomCurrencyFormat = (value) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 2
}).format(value);

const formatPhoneNumber = (phoneNumber) => {
    let inputValue = phoneNumber.replace(/\D/g, '');
    
    if(inputValue.length === 0){
        return "";
    }
    if(inputValue.length > 10){
        inputValue = inputValue.slice(0, 10);
    }
    if(inputValue.length <= 3){
        return `(${inputValue}`;
    }else if(inputValue.length <= 6){
        return `(${inputValue.slice(0, 3)}) ${inputValue.slice(3)}`;
    }else{
        return `(${inputValue.slice(0, 3)}) ${inputValue.slice(3, 6)}-${inputValue.slice(6)}`;
    }
};

function formatDate(dateString){
    if(!dateString){return '';}
    
    try{
        const date = parse(dateString, 'yyyy-MM-dd', new Date());
        return format(date, 'MM-dd-yyyy');
    }catch(error){
        console.error('Error formatting date:', error);
        return dateString;
    }
};



const US_STATES = [
    { value: '', label: 'Select a state' },
    { value: 'AL', label: 'Alabama' },
    { value: 'AK', label: 'Alaska' },
    { value: 'AZ', label: 'Arizona' },
    { value: 'AR', label: 'Arkansas' },
    { value: 'CA', label: 'California' },
    { value: 'CO', label: 'Colorado' },
    { value: 'CT', label: 'Connecticut' },
    { value: 'DE', label: 'Delaware' },
    { value: 'DC', label: 'District of Columbia' },
    { value: 'FL', label: 'Florida' },
    { value: 'GA', label: 'Georgia' },
    { value: 'HI', label: 'Hawaii' },
    { value: 'ID', label: 'Idaho' },
    { value: 'IL', label: 'Illinois' },
    { value: 'IN', label: 'Indiana' },
    { value: 'IA', label: 'Iowa' },
    { value: 'KS', label: 'Kansas' },
    { value: 'KY', label: 'Kentucky' },
    { value: 'LA', label: 'Louisiana' },
    { value: 'ME', label: 'Maine' },
    { value: 'MD', label: 'Maryland' },
    { value: 'MA', label: 'Massachusetts' },
    { value: 'MI', label: 'Michigan' },
    { value: 'MN', label: 'Minnesota' },
    { value: 'MS', label: 'Mississippi' },
    { value: 'MO', label: 'Missouri' },
    { value: 'MT', label: 'Montana' },
    { value: 'NE', label: 'Nebraska' },
    { value: 'NV', label: 'Nevada' },
    { value: 'NH', label: 'New Hampshire' },
    { value: 'NJ', label: 'New Jersey' },
    { value: 'NM', label: 'New Mexico' },
    { value: 'NY', label: 'New York' },
    { value: 'NC', label: 'North Carolina' },
    { value: 'ND', label: 'North Dakota' },
    { value: 'OH', label: 'Ohio' },
    { value: 'OK', label: 'Oklahoma' },
    { value: 'OR', label: 'Oregon' },
    { value: 'PA', label: 'Pennsylvania' },
    { value: 'RI', label: 'Rhode Island' },
    { value: 'SC', label: 'South Carolina' },
    { value: 'SD', label: 'South Dakota' },
    { value: 'TN', label: 'Tennessee' },
    { value: 'TX', label: 'Texas' },
    { value: 'UT', label: 'Utah' },
    { value: 'VT', label: 'Vermont' },
    { value: 'VA', label: 'Virginia' },
    { value: 'WA', label: 'Washington' },
    { value: 'WV', label: 'West Virginia' },
    { value: 'WI', label: 'Wisconsin' },
    { value: 'WY', label: 'Wyoming' }
];

/** Update the URL query parameters without reloading the page
 * @param {string} key - The key of the query parameter to update
 * @param {string} value - The value of the query parameter to update
 */
export const updateUrlQuery = (key, value) => {
    // console.log('updateUrlQuery: ', key, value);
    const url = new URL(window.location);
    if (value !== null && value !== undefined && value !== '') {
        url.searchParams.set(key, value);
    } else {
        url.searchParams.delete(key);
    }
    // Update the URL without triggering a page reload
    window.history.replaceState({}, '', url);
};

/** Extracts the invoice number from an invoice string.
 * Expects format like "INV00000184" where 184 is the invoice number.
 * @param {string} invoiceString - The invoice string to parse (e.g., "INV00000184")
 * @returns {number|null} The invoice number as an integer, or null if invalid format
 */
export function getInvoiceNumber(invoiceString){
    if(typeof invoiceString !== 'string'){ return null; }
    
    // Match pattern: INV followed by digits
    const match = invoiceString.match(/^INV(\d+)$/);
    if(!match){ return null; }
    
    const invoiceNumber = parseInt(match[1], 10);
    return isNaN(invoiceNumber) ? null : invoiceNumber;
};


export {
    redirectToHttps, 
    API_URL, 
    BASE_URL,
    TOKEN_COOKIE, 
    isLocal,
    CustomCurrencyFormat, 
    formatPhoneNumber, 
    US_STATES,
    formatDate,
    isStaging
};
